export default __webpack_public_path__ + "static/media/logo_white.a40ed7aa.svg";